export { registerComponent as registerSocialLinksComponent } from '../../components/builtin/SocialLinks/register'
export { default as SocialLinks } from '../../components/builtin/SocialLinks/SocialLinks'
